import Label from "../Label";

import styles from "./styles.module.scss";
import React, { useEffect, useState } from "react";
import UserSelector from "../UserSelector";
import SelectBox from "app/components/OptionButtonGroup/SelectBox";
import TagsPicker from "../TagsPicker";
import ButtonsContainer from "../Buttons/ButtonsContainer";
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";
import { useTranslation } from "react-i18next";
import ButtonVariant from "app/components/Button/ButtonVariant";

const ProgramFilters = ({
  facilityId = null,
  filters,
  setFilters,
  onApply,
  onReset,
  programCategories = null,
  isStudent = false,
  isPublic = false,
}) => {
  const { t } = useTranslation();
  const [tags, setTags] = useState();
  const [coaches, setCoaches] = useState();

  const program_type_options = [
    {
      value: 0,
      label: t("Clinic"),
    },
    {
      value: 1,
      label: t("Series"),
    },
  ];

  const registrations_status_options = [
    {
      value: "open",
      label: t("Open"),
    },
    {
      value: "closed",
      label: t("Closed"),
    },
    {
      value: "opens_in_future",
      label: t("Opens in Future"),
    },
  ];

  const getContainerClass = () => {
    if (isPublic) {
      return styles.public_filter_popup;
    }
    return isStudent ? styles.student_filter_popup_container : styles.filter_popup_container;
  };

  useEffect(() => {
    if (isPublic) {
      schedulingFetchGet(
        `/facility_coaches`,
        { facility_id: facilityId },
        {},
        null,
        true
      )
        .then((response) => {
          setCoaches(response);
        })
        .catch(() => {});
    } else {
      isStudent
        ? schedulingFetchGet(`/coach_profiles`).then((response) => {
            setCoaches(response);
          })
        : schedulingFetchGet(`/facilities/${facilityId}/coach_profiles`).then(
            (response) => {
              setCoaches(response);
            }
          );
    }
  }, []);

  const handleFiltersChange = (key, value) => {
    setFilters((old) => ({ ...old, [key]: value }));
  };
  const registrationStatus = (
    <Label
      text={t("Registration Status")}
      item={(
        <SelectBox
          options={registrations_status_options}
          value={filters.registration_status}
          setValue={(value) =>
            handleFiltersChange("registration_status", value)
          }
          containerStyle={styles.no_padding}
          customControl={{
            height: "40px",
            borderRadius: "8px",
          }}
        />
  )}
    />
  );

  return (
    <div className={getContainerClass()}>
      <h3>{t("Filters")}</h3>
      <div className={styles.filters_container}>
        {isStudent ? (
          registrationStatus
        ) : (
          <Label
            text={t("Program Category")}
            item={(
              <SelectBox
                options={programCategories}
                setValue={(value) => handleFiltersChange("category", value)}
                value={filters.category}
                containerStyle={styles.no_padding}
                customControl={{
                  height: "40px",
                  borderRadius: "8px",
                }}
              />
            )}
          />
        )}
        <Label
          text={t("Attendance")}
          item={(
            <ButtonsContainer
              customStyle={styles.pricing_item}
              items={program_type_options}
              openCalendarSelected={filters?.attendance}
              setOpenCalendarSelected={(value) =>
                handleFiltersChange("attendance", value)
              }
            />
          )}
          containerStyle={styles.label_container}
        />
        <Label
          text={t("Coach")}
          item={(
            <UserSelector
              singleValue
              value={
                filters.coach
                  ? {
                      label: `${filters.coach.firstName}  ${filters.coach.lastName}`,
                      value: filters.coach.id,
                    }
                  : null
              }
              values={coaches}
              selectedUsers={filters.coach}
              setValues={(value) => handleFiltersChange("coach", value)}
              hasArrow
              placeholder={t("Select")}
            />
          )}
        />
        {!isStudent && registrationStatus}
        <Label
          text={t("Tags")}
          item={(
            <TagsPicker
              facilityId={facilityId}
              selectedTags={filters.tags}
              placeholder={t("Select")}
              tags={tags}
              handleChange={(value) => handleFiltersChange("tags", value)}
              setTags={setTags}
              isSearchable={false}
              isPublic={isPublic}
            />
          )}
        />
      </div>
      <div className={styles.button_container}>
        <ButtonVariant
          title={t('Reset')}
          buttonType='secondary-outline'
          onClickFunc={onReset}
          buttonStyles={styles.cancel_button}
        />
        <ButtonVariant
          title={t('Apply')}
          buttonType='primary'
          onClickFunc={onApply}
          buttonStyles={styles.accept_button}
        />
      </div>
    </div>
  );
};

export default ProgramFilters;
